import { UI_PREFIX } from "../constants";
export default (name) => UI_PREFIX + name + ":";
